import MagazineShadow from '@uikit/components/Magazine/MagazineShadow/MagazineShadow';
import MagazineHeroArea from '@uikit/components/MagazineHeroArea/MagazineHeroArea';
import { MagazineArticleHeroAreaProps } from './interfaces';

const MagazineArticleHeroArea = ({ image }: MagazineArticleHeroAreaProps) => (
  <MagazineHeroArea image={image} shadow={<MagazineShadow type={3} />} />
);

export default MagazineArticleHeroArea;
